import { GridColDef } from '@mui/x-data-grid-premium';
import { tableSettingsProps, useTableSettings } from 'src/core/tables/useTableSettings';
import tableHelper from 'src/core/tables/tableHelper';
import { useGetProductLines } from 'src/pages/products/productRequests';

export const useProductLinesTable = (dependency = null): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const [rows] = useGetProductLines(dependency);
  const tableSettings = useTableSettings({ tableName: 'ProductLinesTable', idPath: ['Id'], columns, rows, checkboxSelection: false, disableSelectionOnClick: true });
  return [columns, tableSettings];
};

const columns: GridColDef[] = [
  { field: 'actions', getActions: params => tableHelper.buttonColumn(params, 'Edit', '/products/product-lines/edit?id=', 'Id', 'Edit Product Line'), type: 'actions', headerName: '', width: 30 },
  { field: 'Id', headerName: 'Id', width: 60 },
  { field: 'Name', headerName: 'Name', flex: 0.6 },
  { field: 'Manufacturer_Id', headerName: 'Manufacturer Id', flex: 0.6, type: 'number', valueGetter: tableHelper.getFieldKeyOrValue },
  { field: 'Manufacturer_Name', headerName: 'Manufacturer Name', flex: 0.6, valueGetter: tableHelper.getFieldKeyOrValue },
  { field: 'View', renderCell: params => tableHelper.buttonColumn(params, 'View', '/products/products?field=ProductLine_Key&value=', 'Id', 'View Products'), headerName: 'View', width: 40 },
];

export { mapObjectsWithId } from 'src/core/tables/useTableSettings';
